<template>
  <!-- Modal Form -->
  <b-modal
    id="modal-form"
    :title="editTarget ? 'Edit Jadwal Libur' : 'Tambah Jadwal Libur'"
    ok-title="Simpan"
    cancel-title="Batal"
    size="md"
    @ok="modalOnSubmit"
    @hidden="modalOnHide"
    @show="modalOnShow"
    header-class="border-0 pb-0"
    footer-class="border-0 pt-0"
    body-class="pt-2 pb-4"
    ok-variant="primary font-weight-bold px-6 rounded-lg"
    cancel-variant="light font-weight-bold px-6 rounded-lg text-muted"
  >
    <b-form @submit.stop.prevent="formOnSubmit">
      <!-- Doctor Select -->
      <template v-if="!hasDoctor">
        <div class="form-group mb-4">
          <label for="input-doctor" class="font-weight-bold text-dark-75 mb-2">Pilih Dokter:</label>
          <treeselect
            id="input-doctor"
            v-model="form.doctor_id"
            :multiple="false"
            @select="selectDoctorOnChange"
            :options="doctors"
            placeholder="Pilih Dokter"
            class="hc-clean-treeselect"
          />
          <small class="text-danger mt-1 d-block" v-if="error.doctor_id">{{ error.doctor_id }}</small>
        </div>
      </template>

      <div class="row no-gutters mx-n2 mt-4">
        <!-- Date Picker Start -->
        <div class="col-lg-6 col-12 px-2">
          <div class="form-group mb-4">
            <label for="input-date" class="font-weight-bold text-dark-75 mb-2">Dari Tgl:</label>
            <b-form-datepicker
              id="input-date"
              v-model="form.start_date"
              placeholder="Pilih Tanggal"
              :date-disabled-fn="disableDate"
              locale="id"
              class="rounded-lg hc-clean-datepicker"
              boundary="window"
              @input="formaterDate"
            ></b-form-datepicker>
            <small class="text-danger mt-1 d-block" v-if="error.start_date">{{ error.start_date }}</small>
          </div>
        </div>

        <!-- Date Picker End -->
        <div class="col-lg-6 col-12 px-2">
          <div class="form-group mb-4">
            <label for="input-date-end" class="font-weight-bold text-dark-75 mb-2">Sampai Tgl:</label>
            <b-form-datepicker
              id="input-date-end"
              v-model="form.end_date"
              placeholder="Pilih Tanggal"
              :date-disabled-fn="disableDate"
              locale="id"
              class="rounded-lg hc-clean-datepicker"
              boundary="window"
              right
              @input="formaterDateEnd"
            ></b-form-datepicker>
            <small class="text-danger mt-1 d-block" v-if="error.end_date">{{ error.end_date }}</small>
          </div>
        </div>
      </div>

      <div class="form-group mb-4">
        <div class="p-3 rounded-lg" style="background: rgba(var(--skin-secondary-rgb), 0.06); border: 1px dashed rgba(var(--skin-secondary-rgb), 0.2);">
          <div class="d-flex align-items-center">
            <i class="fas fa-fw fa-info-circle text-info mr-2"></i>
            <span class="text-muted font-size-sm">
              Kosongkan input <em class="font-weight-bold text-dark-75">sampai tanggal</em> jika libur hanya 1 hari
            </span>
          </div>
        </div>
      </div>

      <!-- Notes input -->
      <div class="form-group mb-0">
        <label for="input-notes" class="font-weight-bold text-dark-75 mb-2"
          >Keterangan: <em class="text-muted font-weight-normal">opsional</em></label
        >
        <b-form-textarea
          id="input-notes"
          v-model="form.notes"
          placeholder="Tuliskan keterangan libur di sini..."
          rows="3"
          max-rows="6"
          class="rounded-lg bg-light border-0 shadow-none px-4 py-3"
        ></b-form-textarea>
        <small class="text-danger mt-1 d-block" v-if="error.notes">{{ error.notes }}</small>
      </div>
    </b-form>
  </b-modal>
</template>

<style scoped>
/* Fix Double Borders */
::v-deep .hc-clean-datepicker.form-control {
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

::v-deep .hc-clean-datepicker.form-control > button.btn {
  border: 1px solid #E7EDF4;
  border-radius: 0.5rem;
  background-color: #FFFFFF;
  padding: 0.375rem 0.75rem;
  box-shadow: none !important;
}

::v-deep .hc-clean-datepicker.form-control > button.btn:focus,
::v-deep .hc-clean-datepicker.form-control > button.btn:focus-visible {
  outline: 3px solid rgba(var(--skin-secondary-rgb), 0.24) !important;
  outline-offset: 0px !important;
  border-color: var(--skin-secondary) !important;
}

::v-deep .hc-clean-treeselect {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .hc-clean-treeselect .vue-treeselect__control {
  border: 1px solid #E7EDF4 !important;
  border-radius: 0.5rem;
  box-shadow: none !important;
}

::v-deep .hc-clean-treeselect.vue-treeselect--focused .vue-treeselect__control {
  outline: 3px solid rgba(var(--skin-secondary-rgb), 0.24) !important;
  outline-offset: 0px !important;
  border-color: var(--skin-secondary) !important;
}

::v-deep .hc-clean-treeselect input {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

/* Fix offset circles in calendar */
::v-deep .b-calendar-grid-body .btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
  text-align: center !important;
  padding: 0 !important;
}
</style>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },

  props: {
    form: Object,
    route: String,
    editTarget: String,
    hasDoctor: Boolean,
  },

  data() {
    return {
      // Error
      error: {
        doctor_id: "",
        start_date: "",
        end_date: "",
        notes: "",
      },
      // Options
      doctors: [],
      // Other
      holidayDates: [],
    };
  },

  methods: {
    formaterDate(val) {
      if (val.length == 4) {
        this.form.start_date = this.form.start_date + "-";
      }
      if (val.length == 7) {
        this.form.start_date = this.form.start_date + "-";
      }
    },

    formaterDateEnd(val) {
      if (val.length == 4) {
        this.form.end_date = this.form.end_date + "-";
      }
      if (val.length == 7) {
        this.form.end_date = this.form.end_date + "-";
      }
    },

    resetHolidayDates() {
      this.holidayDates = [];
    },

    async selectDoctorOnChange(evt) {
      this.resetHolidayDates();
      this.holidayDates = await module.get(
        `holidays/get-date-by-doctor/${evt.id}`
      );
    },

    async datePickerOnClick() {
      this.resetHolidayDates();
      this.holidayDates = await module.get(
        `holidays/get-date-by-doctor/${this.$route.params.id}`
      );
    },

    disableDate(ymd, date) {
      if (this.holidayDates.length != 0) {
        const day = date.getDate();
        for (let i = 0; i < this.holidayDates.length; i++) {
          if (ymd === this.holidayDates[i].start_date.split(" ")[0]) {
            return true;
          }
        }
      }
    },

    async getDoctorsOption() {
      let response = await module.setDoctorTreeSelect("doctors");
      // Success
      if (response.state == "success") {
        // Set Option Select
        this.doctors = response.data;
        this.doctors.unshift({
          label: "Pilih Dokter",
          id: "",
          isDisabled: true,
        });
      }
    },

    async formOnSubmit() {
      let route;
      this.editTarget == ""
        ? (route = this.route)
        : (route = `${this.route}/${this.editTarget}`);
      let response = await module.submit(this.form, route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        // Hide Modal
        this.$bvModal.hide("modal-form");
        // Refresh Table
        this.$emit("formOnSubmit");
      }
    },

    modalOnSubmit(evt) {
      evt.preventDefault();
      this.formOnSubmit();
    },

    modalOnShow() {
      if (this.hasDoctor) this.datePickerOnClick();
    },

    modalOnHide(evt) {
      this.error = validation.clearValidationError(this.error);
      this.form = validation.clearForm(this.form);
      // Reset Form & Edit Target
      delete this.form["_method"];
      if (this.hasDoctor) {
        this.form.doctor_id = this.$route.params.id;
      }
    },
  },

  mounted() {
    if (!this.hasDoctor) this.getDoctorsOption();
  },
};
</script>

<style>
</style>